<template>
    <typo name="ci-body" :class="cspClasses">
        <v-card class="indemnity-container" elevation="3">
            <div class="indemnity-part" v-if="checkIsNumber(annotation.minimumSeniority)">
                <annotation-note>
                    <div class="indemnity-line">
                        <div class="indemnity-line-label">
                            Ancienneté minimum
                        </div>
                        <div>
                            {{ parseNumericValue(annotation.minimumSeniority) }}
                            {{ getOptionLabel(annotation.minimumSeniorityUnit) }}
                        </div>
                    </div>
                </annotation-note>
            </div>
            <div class="indemnity-part">
                <typo name="body-14-normal" v-html="annotation.amountForSeniority" />
            </div>
            <div
                class="indemnity-part"
                v-if="checkIsNumber(annotation.ceiling) || checkIsNumber(annotation.floor)"
            >
                <annotation-note>
                    <div v-if="checkIsNumber(annotation.ceiling)" class="indemnity-line">
                        <div class="indemnity-line-label">
                            Plafond
                        </div>
                        <div>
                            {{ parseNumericValue(annotation.ceiling) }}
                            {{ getOptionLabel(annotation.ceilingUnit) }}
                        </div>
                    </div>
                    <div v-if="checkIsNumber(annotation.floor)" class="indemnity-line">
                        <div class="indemnity-line-label">
                            Planché
                        </div>
                        <div>
                            {{ parseNumericValue(annotation.floor) }}
                            {{ getOptionLabel(annotation.floorUnit) }}
                        </div>
                    </div>
                </annotation-note>
            </div>
            <div v-if="filteredTags.length > 0" class="tags-container">
                <span v-for="tag in filteredTags" :key="tag._uid" class="tags-badge">
                    {{ getOptionLabel(tag) }}
                </span>
            </div>
        </v-card>
    </typo>
</template>

<script>
import Vue from "vue";
import { get, isNull } from "lodash";
import AnnotationNote from "../AnnotationNote.vue";

export default Vue.extend({
    components: { AnnotationNote },
    props: ["annotation", "annotationOptions"],
    computed: {
        cspClasses() {
            return this.annotation.cspCodes
                .map(code => `csp-${code}`)
                .join(" ")
                .toLowerCase();
        },
        filteredTags() {
            return this.annotation.tags.filter(tag => tag !== "compact-info");
        },
    },
    methods: {
        getOptionLabel(code) {
            return get(this.annotationOptions, `${code}.label`, "").toLowerCase();
        },
        parseNumericValue(indemnityValue) {
            return Number.isInteger(indemnityValue)
                ? indemnityValue
                : indemnityValue.toLocaleString("fr-FR", {
                      maximumFractionDigits: 4,
                      minimumFractionDigits: 2,
                  });
        },
        checkIsNumber(number) {
            if (isNull(number)) return false;
            return !isNaN(this.annotation.ceiling);
        },
    },
});
</script>

<style lang="sass" scoped>
.indemnity-container
    width: 100%
    border: 1px solid white
    box-sizing: border-box
    margin-bottom: 16px

.indemnity-part
    box-sizing: border-box
    margin: 24px

.indemnity-line
    display: flex
    align-items: center
    justify-content: space-between
    margin: 8px 0

.indemnity-line-label
    font-weight: bold

.tags-badge
    display: inline-block
    border: 1px solid $color-secondary
    border-radius: 4px
    padding: 4px 16px
    margin: 1px 0

.tags-container
    border-top: 1px solid $color-grey
    width: 100%
    padding: 16px 24px
</style>
